import React, { useEffect, useState } from "react";
import BlogCard from "./../BlogCard";
import classes from "./styles.module.scss";
import { useMediaQuery } from "hooks/useMediaQuery";
import { cn } from "utils/styling";
import Text from "components/Brand/Text";
import EPButton from "components/UI/EPButton";

const BlogList = ({ blogs, title, showBtn = true }) => {
  const [loadMore, setLoadMore] = useState(false);
  const [limit, setLimit] = useState(15);
  const [isMobile, isTab] = useMediaQuery([
    "(max-width: 767px)",
    "(max-width: 1024px)",
  ]);

  useEffect(() => {
    if (isTab && !isMobile) {
      setLimit(12);
    } else if (isMobile) {
      setLimit(7);
    } else {
      setLimit(15);
    }
  }, [isTab, isMobile]);

  return (
    <div className={classes.container}>
      {title && (
        <Text
          as={showBtn ? "h1" : "div"}
          className={cn(classes.title, showBtn && "text-center")}
        >
          {title}
        </Text>
      )}
      <div className={classes.blogList}>
        {blogs?.length > 0 &&
          blogs
            .filter((val, index) => index < (loadMore ? blogs.length : limit))
            .map((item, index) => {
              return <BlogCard noTag={showBtn} key={index} blog={item} />;
            })}
      </div>
      {showBtn && (
        <EPButton variant="secondary" className={"mx-auto px-8 py-5 !text-xl mt-6 max-w-[200px] block"} onClick={() => setLoadMore(!loadMore)}>
          {loadMore ? "Show Less" : "Show More"}
        </EPButton>
      )}
    </div>
  );
};

export default BlogList;
